module.exports = __webpack_public_path__ + "img/bg3.fd4b8cc4.png";